import FileDownload from 'js-file-download';
import PropTypes from "prop-types";
import React, { Component } from "react";
import Select from 'react-select';
import withStyles from "@material-ui/core/styles/withStyles";
import { isNumber, map, orderBy, remove, uniqueId } from "lodash";
import * as Animated from "react-select/lib/animated";

import Button from "components/CustomButtons/Button.jsx";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomInput from "components/EnergyCompany/Input/Input";
import Dashboard from "./Dashboard";
import DeleteIcon from "@material-ui/icons/Delete";
import EmpresasFiltradas from "./relatorio-partials/EmpresasFiltradas";
import { capitalizeString } from "services/utils";
import { fetchCidades } from "services/dados-gerais";
import { fetchParametros, fetchReport, fetchReportPage, getRelatorioCSV } from "services/busca-cativo";

const buscaCativoStyle = theme => ({
  atributosWrapper: {
    display: "flex",
  },
  atributos: {
    display: "grid",
    gridColumnGap: "15px",
    gridRowGap: "15px",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    width: "100%",
  },
  atributosAction: {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    marginLeft: "15px",
  },
  atributosActionWrapper: {
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: "10px",
  },
  buscarButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "20px 0",
    "& > div": {
      position: "relative",
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  estados: {
    display: "grid",
    gridColumnGap: "15px",
    gridRowGap: "15px",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  },
  filtroWrapper: {
    marginBottom: "15px",
  },
  novoAtributo: {
    cursor: "pointer",
  },
  ordenaçãoWrapper: {
    display: "grid",
    gridColumnGap: "15px",
    gridRowGap: "15px",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  },
});

class BuscaCativo extends Component {
  state = {
    ...this.getPristineState(),
  };

  componentDidMount() {
    fetchParametros().then(({ data }) => {
      this.setState({ parametros: data });
    });
  }

  getPristineState() {
    return {
      atributos: [{ uniqueId: uniqueId("atributo") }],
      availableCidades: [],
      cidades: [],
      cnaes: [],
      divisoesCNAE: [],
      empresa: undefined,
      estados: [],
      gruposCNAE: [],
      classesCNAE: [],
      itens: undefined,
      loading: false,
      loadingCidades: false,
      ordenacao: "",
      parametros: {},
      regioes: [],
      relatorio: undefined,
      sentidoOrdenacao: "",
      subgroups: [],
      submercados: [],
    };
  }

  addAtributo = () => {
    this.setState({ atributos: this.state.atributos.concat({ uniqueId: uniqueId("atributo") }) });
  }

  noOptionsMessage(options) {
    return options ? "Sem resultado" : "Carregando...";
  }

  removeAtributo = (indexToRemove) => {
    this.setState(prevState => {
      let atributos = [...prevState.atributos];
      remove(atributos, (val, index) => index === indexToRemove);
      return { atributos };
    });
  }

  clearSelections = () => {
    this.setState({
      ...this.getPristineState(),
      parametros: this.state.parametros,
    });
  }

  requestBuscaFiltrada = () => {
    const { atributos, cidades, classesCNAE, cnaes, divisoesCNAE, estados, gruposCNAE, ordenacao, regioes, sentidoOrdenacao, subgroups, submercados } = this.state;

    this.setState({
      empresa: undefined,
      itens: undefined,
      loading: true,
      relatorio: undefined,
    });

    fetchReport({
      atributos,
      cidades,
      cnaes,
      divisoesCNAE,
      estados,
      gruposCNAE,
      classesCNAE,
      ordenacao,
      regioes,
      sentidoOrdenacao,
      subgroups,
      submercados,
    }).then(({ data }) => {
      this.setState({
        itens: data.relatorio.itens,
        loading: false,
        relatorio: data.relatorio,
      });
    }).catch(() => this.setState({ loading: false }));
  }

  requestNextPage = page => {
    fetchReportPage(this.state.relatorio.id, page - 1).then(({ data }) => {
      this.setState({
        itens: data.relatorio.itens,
        relatorio: data.relatorio,
      });
    });
  }

  searchEmpresa = empresa => {
    this.setState({ empresa });
  }

  setEstadoAndFetchCidades = estados => {
    this.setState({ estados, loadingCidades: true });

    if (estados && estados.length === 1) {
      fetchCidades(estados[0].id).then(res => {
        this.setState({ availableCidades: res.data, loadingCidades: false });
      });
    } else {
      this.setState({ availableCidades:[], cidades: [], loadingCidades: false });
    }
  }

  updateAtributo = (key, value, index) => {
    this.setState(prevState => {
      const atributos = [...prevState.atributos];
      atributos[index][key] = value;

      if (key === 'tipo') {
        atributos[index]['condicao'] = atributos[index]['condicao'] || this.state.parametros.condicoes[0];
        atributos[index]['valor'] = atributos[index]['valor'] || 0;
        atributos[index]['unidade'] = atributos[index]['unidade'] || this.state.parametros.unidades[0];
      }

      return { atributos };
    });
  }

  updateSubmercado = value => {
    if (value.length) {
      this.setState({ cidades: [], estados: [], submercados: value });
    } else {
      this.setState({ submercados: value });
    }
  }

  render() {
    const { classes } = this.props;
    const {
      atributos,
      availableCidades,
      cidades,
      subgroups,
      cnaes,
      divisoesCNAE,
      empresa,
      estados,
      gruposCNAE,
      classesCNAE,
      itens,
      loading,
      loadingCidades,
      ordenacao,
      parametros,
      regioes,
      relatorio,
      sentidoOrdenacao,
      submercados } = this.state;

    return (
      <div>
        <div className={classes.filtroWrapper}>
          <h4>Submercado</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isDisabled={!!regioes.length || !!estados.length}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.submercados)}
            onChange={this.updateSubmercado}
            options={parametros.submercados}
            placeholder="Submercado"
            value={submercados}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <h4>Regiões</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isDisabled={!!submercados.length || !!estados.length}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.regioes)}
            onChange={e => this.setState({ regioes: e })}
            options={parametros.regioes}
            placeholder="Regiões"
            value={regioes}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <div className={classes.estados}>
            <div>
              <h4>Estados</h4>
              <Select
                components={Animated}
                getOptionLabel={option => option.nome}
                getOptionValue={option => option.id}
                isClearable
                isDisabled={!!submercados.length || !!regioes.length}
                isMulti
                noOptionsMessage={() => this.noOptionsMessage(parametros.estados)}
                onChange={this.setEstadoAndFetchCidades}
                options={parametros.estados}
                placeholder="Estados"
                value={estados}
              />
            </div>

            <div>
              <h4>Cidades</h4>
              <Select
                components={Animated}
                getOptionLabel={option => capitalizeString(option.nome)}
                getOptionValue={option => option.id}
                isDisabled={!!submercados.length || !!regioes.length || estados.length > 1}
                isLoading={loadingCidades}
                isMulti
                loadingMessage={() => "Carregando cidades..."}
                noOptionsMessage={() => "Sem resultado"}
                onChange={e => this.setState({ cidades: e })}
                options={availableCidades}
                placeholder="Cidades"
                value={cidades}
              />
            </div>
          </div>
        </div>

        <div className={classes.filtroWrapper}>
          <h4>Subgrupos</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.subgroups)}
            onChange={e => this.setState({ subgroups: e })}
            options={parametros.subgroups}
            placeholder="Subgrupos"
            value={subgroups}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <h4>Divisões CNAE</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.divisoesCNAE)}
            onChange={e => this.setState({ divisoesCNAE: e })}
            options={parametros.divisoesCNAE}
            placeholder="Divisões CNAE"
            value={divisoesCNAE}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <h4>Grupos CNAE</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.gruposCNAE)}
            onChange={e => this.setState({ gruposCNAE: e })}
            options={parametros.gruposCNAE}
            placeholder="Grupos CNAE"
            value={gruposCNAE}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <h4>Classes CNAE</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.classesCNAE)}
            onChange={e => this.setState({ classesCNAE: e })}
            options={parametros.classesCNAE}
            placeholder="Classes CNAE"
            value={classesCNAE}
          />
        </div>

        <div className={classes.filtroWrapper}>
          <h4>CNAEs</h4>
          <Select
            components={Animated}
            getOptionLabel={option => option.nome}
            getOptionValue={option => option.id}
            isMulti
            noOptionsMessage={() => this.noOptionsMessage(parametros.cnaes)}
            onChange={e => this.setState({ cnaes: e })}
            options={orderBy(parametros.cnaes, ["nome"])}
            placeholder="CNAEs"
            value={cnaes}
          />
        </div>

        <div className={classes.filtroWrapper}>
          {map(atributos, (atributo, index) => (
            <div className={classes.filtroWrapper} key={atributo.uniqueId}>
              <div className={classes.atributosWrapper}>
                <div className={classes.atributos}>
                  <div>
                    <h4>Filtro</h4>
                    <Select
                      components={Animated}
                      getOptionLabel={option => option.nome}
                      getOptionValue={option => option.id}
                      noOptionsMessage={() => this.noOptionsMessage(parametros.atributos)}
                      onChange={e => this.updateAtributo('tipo', e, index)}
                      options={parametros.atributos}
                      placeholder="Tipo"
                      value={atributo.tipo}
                    />
                  </div>

                  <div>
                    <h4>Condição</h4>
                    <Select
                      components={Animated}
                      getOptionLabel={option => option.nome}
                      getOptionValue={option => option.id}
                      noOptionsMessage={() => this.noOptionsMessage(parametros.condicoes)}
                      onChange={e => this.updateAtributo('condicao', e, index)}
                      options={parametros.condicoes}
                      placeholder="Condição"
                      value={atributo.condicao}
                    />
                  </div>

                  <div>
                    <h4>Valor</h4>
                    <CustomInput
                      onChange={({ target }) => this.updateAtributo('valor', target.value === "" ? "" : Number(target.value), index)}
                      placeholder="Valor"
                      type="number"
                      value={isNumber(atributo.valor) ? atributo.valor : ""}
                    />
                  </div>

                  <div>
                    <h4>Unidade</h4>
                    <Select
                      components={Animated}
                      getOptionLabel={option => option.nome}
                      getOptionValue={option => option.id}
                      label="Unidade"
                      noOptionsMessage={() => this.noOptionsMessage(parametros.unidades)}
                      onChange={e => this.updateAtributo('unidade', e, index)}
                      options={parametros.unidades}
                      placeholder="Unidade"
                      value={atributo.unidade}
                    />
                  </div>
                </div>
                <div className={classes.atributosActionWrapper}>
                  <div className={classes.atributosAction}>
                    <DeleteIcon onClick={() => this.removeAtributo(index)} />
                  </div>
                </div>
              </div>
            </div>
          ))}

          <a className={classes.novoAtributo} onClick={this.addAtributo}>
            + Adicionar novo filtro
          </a>
        </div>

        <div className={classes.ordenaçãoWrapper}>
          <div>
            <h4>Ordenação</h4>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              noOptionsMessage={() => this.noOptionsMessage(parametros.atributosOrdenacao)}
              onChange={e => this.setState({ ordenacao: e })}
              options={parametros.atributosOrdenacao}
              placeholder="Ordenação"
              value={ordenacao}
            />
          </div>

          <div>
            <h4>Sentido da Ordenação</h4>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              onChange={e => this.setState({ sentidoOrdenacao: e })}
              options={[{ id: false, nome: "A -> Z" }, { id: true, nome: "Z -> A" }]}
              placeholder="Sentido da ordenação"
              value={sentidoOrdenacao}
            />
          </div>
        </div>

        <div className={classes.buscarButtonWrapper}>
          <div>
            <Button
              color="rose"
              disabled={loading}
              onClick={this.clearSelections}
            >
              Limpar Filtros
            </Button>
            <Button
              color="info"
              disabled={loading}
              onClick={this.requestBuscaFiltrada}
            >
              Buscar
            </Button>
            {loading && <CircularProgress className={classes.buttonProgress} size={24} />}
          </div>
        </div>

        {itens && itens.length > 0 && (
          <EmpresasFiltradas
            colunaFixa={{ key: 'nomeEmpresa' , label: 'Razão Social' }}
            downloadCSV={() => {
              getRelatorioCSV(relatorio.id, 0).then(response => {
                FileDownload(response.data, 'empresas-busca-cativo.csv');
              });
            }}
            itens={itens}
            relatorio={relatorio}
            requestNextPage={this.requestNextPage}
            searchEmpresa={this.searchEmpresa}
          />
        )}

        {itens && itens.length === 0 && (
          <h3>Nenhuma empresa encontrada</h3>
        )}

        {empresa && (
          <Dashboard selected={{ id: empresa.idEmpresa }} simplified />
        )}
      </div>
    );
  }
}

BuscaCativo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export { BuscaCativo as DashboardComponent };
export default withStyles(buscaCativoStyle)(BuscaCativo);



// WEBPACK FOOTER //
// ./src/views/Dashboard/BuscaCativo.jsx